
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb966"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb966"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $cX88K = parcelRequire("cX88K");
(async function() {
    (0, $cX88K.allShotsCsv)((res)=>{
        const url = window.URL.createObjectURL(res);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        // the filename you want
        a.download = "golf-shots.csv";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }, "Sorry there was an issue downloading your file.");
})();


//# sourceMappingURL=exportCsv.48224e90.js.map
